// frontend/src/components/auth/TenantRoute.js
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { tenantNameToSlug } from '../../utils/tenantSlug';

const TenantRoute = ({ children }) => {
  const { tenant } = useParams();
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (user && user.tenant_name) {
    const urlFriendlyTenantName = tenantNameToSlug(user.tenant_name);

    if (tenant !== urlFriendlyTenantName) {
      return <Navigate to={`/${urlFriendlyTenantName}`} replace />;
    }
  }

  return children;
};

export default TenantRoute;